import React from 'react';
import styles from '../../styles/styles';

const CheckoutSteps = ({ active }) => {
  return (
    <div className="w-full flex justify-center">
      <div className="w-[90%] 800px:w-[50%] flex items-center flex-nowrap justify-between">
        {/* Shipping Step */}
        <div className={`${styles.noramlFlex} flex-1 min-w-[30%]`}>
          <div className={`${styles.cart_button}`}>
            <span className={`${styles.cart_button_text}`}>Shipping</span>
          </div>
        </div>

        {/* Payment Step */}
        <div className={`${styles.noramlFlex} flex-1 min-w-[30%]`}>
          <div
            className={`${
              active > 1
                ? `${styles.cart_button}`
                : `${styles.cart_button} !bg-[#6add98]`
            }`}
          >
            <span
              className={`${
                active > 1
                  ? `${styles.cart_button_text}`
                  : `${styles.cart_button_text} !text-[#ffffff]`
              }`}
            >
             Payment
            </span>
          </div>
        </div>

        {/* Success Step */}
        <div className={`${styles.noramlFlex} flex-1 min-w-[30%]`}>
          <div
            className={`${
              active > 2
                ? `${styles.cart_button}`
                : `${styles.cart_button} !bg-[#6add98]`
            }`}
          >
            <span
              className={`${
                active > 2
                  ? `${styles.cart_button_text}`
                  : `${styles.cart_button_text} !text-[#ffffff]`
              }`}
            >
              Success
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutSteps;

